// Module
var code = "<p>AES <strong>cannot</strong> advise you on tax matters. If you have questions, contact a tax professional or the IRS at <strong>1-800-829-1040</strong> or visit <a href=\"https://www.irs.gov/\">IRS.gov</a>.</p> ";
// Exports
export default code;